<modal-window [title]="title" [modal]="true" [show]="show">
                    <div class="vt-modal-body">
                        <p [innerHtml]="message"></p>
                    </div>
                    <div class="vt-modal-footer">
                        <button class="btn btn-primary" (click)="close()">Ok</button>
                    </div>
                </modal-window>